import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  Box,
  FileText,
  Filter,
  PlusCircle,
  RotateCcw,
  Sliders,
  List,
  User,
  Calendar,
} from "feather-icons-react/build/IconComponents";


import Select from "react-select";
import { Table } from "antd";
import { setheadertoggle } from "../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import { getAllAccountType, getSalesReport } from "../../services/ReportApiService";
import { fetchSection } from "../../redux/userSetting";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../core/json/DatatablePagingParameters";
import { renderTooltip } from "../../redux/helper";
import { Checkbox } from "antd";
import { DatePicker } from "antd";
// import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";

import {
  exportExcel,
  exportPDF,
  printReport,
} from "../../core/utils/StockReportUtils";
import LoadingUtils from "../../core/utils/LoadingUtils";
import { data } from "jquery";
  
const TypeFilter = [
    { value: 0, label: "Pay In" },
    { value: 1, label: "Pay Out" },
  ];

  
  
const PayInOutReport = () => {
  const [typeFilter, setTypeFilter] = useState(null);
  const [acctypeFilter, setaccTypeFilter] = useState(null);
 const [AcctypeFilter, setAccTypeFilter] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [stockData, setstockData] = useState();
  const [sectionval, setsectionval] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const title = "TAX REPORT";
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const tableRef = useRef(null);
  const { sectionList } = useSelector(
    (state) => state.usersetting
  );
  const [decimalpoints, setDecimalPoints] = useState(2);
    const {
     
      settingList,
   
    } = useSelector((state) => state.usersetting);
    useEffect(() => {
        
        const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);

            dispatch(fetchSection(branch.guid));
            handleStockInfullReport();
            handleAccountType();
      }, [branch, fromDate, toDate]);
 const currfmt = useSelector((state) => {
    const match = state.usersetting?.settingList?.currencyFormat?.toString()?.match(/\.0+/);
    return match ? match[0]?.length - 1 : 0;
  });

 const handleStockInReport = async (page, size) => {
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    try {
      const response = await getSalesReport({
        DatatablePagingParameters,
        Filters,
      });
      setstockData(response?.data?.salesReportDetail);
      setFilteredData(stockData);
      
      settotalcount(stockData?.length);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
    }
  };
  const handleStockInfullReport = async () => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    const formattedfromDate = dayjs(fromDate).format("YYYY-MM-DD");
    const formattedtoDate = dayjs(toDate).format("YYYY-MM-DD");
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = formattedfromDate;
    Filters.ToDate = formattedtoDate;
    Filters.Type = TypeFilter?.value;

    try {
      const response = await getSalesReport({
        DatatablePagingParameters,
        Filters,
      });
      setstockData(response?.data?.salesReportDetail);
      setFilteredData(response?.data?.salesReportDetail);
      const totalCount = 0;
      
      // Set the total count
      settotalcount(response?.data?.salesReportDetail?.length);
      setloading(false);
    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
      setloading(false);
    }
  };

const handleAccountType = async () => {
    try {
      const response = await getAllAccountType();
      const options = response.data.map((item) => ({
        value: item.id,       // or whatever ID field exists
        label: item.name,
      }));
      setAccTypeFilter(options);

    } catch (error) {
      console.error(
        "Error Fetching Account Type!",
        error?.response?.data?.Message
      );
      setloading(false);
    }
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
 const [filteredData, setFilteredData] = useState(stockData); // Start with full data
  const menuItems = [
    { value: "1", label: "DATE", checked: true },
    { value: "2", label: "Bill No", checked: true },
    { value: "3", label: "Section", checked: true },
    { value: "4", label: "Gross Amount", checked: true },
    { value: "5", label: "Vat Amount", checked: true },
    { value: "6", label: "Discount", checked: true },
    { value: "7", label: "Bill Total", checked: true },
    
  ];

  const columns = [
    {
      title: "Date",
      key: "1",
      dataIndex: "transactionDate",
      render: (text) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        };

        return <span>{formatDate(text)}</span>;
      },
      sorter: (a, b) => a.transactionDate - b.transactionDate,
    },
    { 
      title: 'Bill No',
      dataIndex: 'billNo', 
      key: '2',
       sorter: (a, b) => a.billno - b.billno,
    },
        {
      title: "Section",
      key: "3",
      dataIndex: "section",
      render: (text) => <span>{text.name}</span>,
      sorter: (a, b) => a.section?.name?.length - b.section?.name?.length,
    },
    {
      title: "Gross Amount",
      key: "4",
      dataIndex: "rateTotal",
        sorter: (a, b) => a.rateTotal - b.rateTotal,
        render: (value) => Number(value).toFixed(currfmt)
    },
    {
      title: "Vat Amount",
      key: "5",
      dataIndex: "taxAmount",
      sorter: (a, b) => a.taxAmount - b.taxAmount,
        render: (value) => Number(value).toFixed(currfmt)
    },
        {
      title: "Discount",
      key: "6",
      dataIndex: "discount",
      sorter: (a, b) => a.discount - b.discount,
        render: (value) => Number(value).toFixed(currfmt)
    },
    {
      title: "Bill Total",
      key: "7",
      dataIndex: "netTotal",
      sorter: (a, b) => a.netTotal - b.netTotal,
        render: (value) => Number(value).toFixed(currfmt)
    },
    
  ];

  const [selectedColumns, setSelectedColumns] = useState([]);

  useEffect(() => {
    // Set default selected columns based on menuItems' checked status
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      .map((item) => columns.find((col) => col.key === item.value));

    setSelectedColumns(initialSelectedColumns);
    handleStockInfullReport();
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      // Add column if checkbox is checked
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns.find((col) => col.key === columnKey),
        ];

        // Sort the array by col.key in ascending order
        return updatedColumns.sort((a, b) => (a.key > b.key ? 1 : -1));
      });
    } else {
      // Remove column if checkbox is unchecked
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    console.log(date, "from date");
    setFromDate(date);

    setToDate(null); // reset to date when from date changes
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    console.log(date, "to date");
  };
  const getActiveTabData = () => {
    let fieldMapping = {};

    // Function to create the field mapping between column titles and dataIndex values
    const createfieldMapping = (columns) => {
      const mappings = {};
      columns.forEach((col) => {
        if(col.title === "Section")
        {mappings[col.title] = 'section'
          console.log(section, col.title)
        }
        else{
          mappings[col.title] = col.dataIndex; // Map title to dataIndex
        }
      });
      return mappings;
    };
      // Transform data to map isPayIn: 0/1 => "Pay In"/"Pay Out"
    const transformedData = filteredData?.map((item) => ({
    ...item,
    section: item?.section?.name || "",
    netTotal: Number(item.netTotal).toFixed(currfmt),
    rateTotal:Number(item.rateTotal).toFixed(currfmt),
    discount:Number(item.discount).toFixed(currfmt),
    taxAmount:Number(item.taxAmount).toFixed(currfmt),
    
    }));

    
    // Generate the field mapping for the current columns
    fieldMapping = createfieldMapping(columns);

    // Return the filtered data, columns, and field mapping
    return { data: transformedData , columns: selectedColumns,Rname:"TAX Report", fieldMapping };
  };
  

  const totalNet = filteredData?.reduce(
    (sum, record) => sum + record.netTotal,
    0
  );
   const totalTax = filteredData?.reduce(
    (sum, record) => sum + record.taxAmount,
    0
  );
     const totalGross = filteredData?.reduce(
    (sum, record) => sum + record.rateTotal,
    0
  );
       const totalDisc = filteredData?.reduce(
    (sum, record) => sum + record.discount,
    0
  );


const handleFilterChange = (selectedOption) => {
    setTypeFilter(selectedOption);
    var filtered = stockData;
    if (!selectedOption) {
      // Show all if cleared
      setFilteredData(stockData);
      console.log(acctypeFilter,"Account Type")
      if (acctypeFilter !== null && acctypeFilter !== undefined) {
         filtered = filtered.filter(item => item.accountType?.name?.toLowerCase().includes(acctypeFilter.label.toLowerCase()));
       }
    } else {
      // Filter by selected type
        if (acctypeFilter !== null && acctypeFilter !== undefined) {
         filtered = filtered.filter(item => item.accountType?.name?.toLowerCase().includes(acctypeFilter.label.toLowerCase()));
        }
        filtered = filtered.filter(item => item.isPayIn === selectedOption.value);
       
        
    }
     setFilteredData(filtered);
    
  
  };
const handlesectionFilterChange = (selectedOption) => {
    setsectionval(selectedOption);
    var filtered = stockData;
    if (!selectedOption) {
      // Show all if cleared
      setFilteredData(stockData);

    } else {
      // Filter by selected type
        filtered = stockData.filter(item => item.section?.name?.toLowerCase().includes(selectedOption.label.toLowerCase()));
    }
    setFilteredData(filtered);
  
  };
  const handleSearch = (searchText) => {
    let filtered = stockData;
    if (searchText.trim() !== "") {
     const lowerSearch = searchText.toLowerCase();
    filtered = filtered.filter(item =>
      Object.values(item).some(value => {
        // Handle nested objects (e.g. accountType.name)
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some(nestedVal =>
            String(nestedVal).toLowerCase().includes(lowerSearch)
          );
        }
        return String(value).toLowerCase().includes(lowerSearch);
      })
    );
  }
    setFilteredData(filtered);
    
  };
  const section = sectionList?.map((e) => ({
    value: e.guid,
    label: e.name,
  }));
  const handleReset = () => {
    setaccTypeFilter(null);
    setTypeFilter(null);
    setFromDate(dayjs());
    setToDate(dayjs());
    setSearchText("");
    setstockData(null);
    setsectionval(null);
  };
  const footerTotals = {

    netTotal: totalNet?.toFixed(currfmt) || 0.0,
    rateTotal: totalGross?.toFixed(currfmt) || 0.0,
    taxAmount:totalTax?.toFixed(currfmt) || 0.0,
    discount:totalDisc?.toFixed(currfmt) || 0.0,

  };
  const handleRefresh = () => {
    handleStockInfullReport();
    handlesectionFilterChange();
    handleFilterChange();
    };
  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>VAT Report</h4>
                <h6>Manage VAT Report here</h6>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportPDF(getActiveTabData, footerTotals, title)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() =>
                      exportExcel(getActiveTabData, footerTotals, title)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() =>
                      printReport(getActiveTabData, footerTotals, title)
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
                <li>
                                            <OverlayTrigger
                                              placement="top"
                                              overlay={() => renderTooltip("Refresh")}
                                            >
                                              <Link onClick={handleRefresh}>
                                                <RotateCcw/>
                                              </Link>
                                            </OverlayTrigger>
                                          </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
               <div className="search-set">
                                <div className="search-input">
                                  <Link to="#" className="btn btn-searchset">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-search"
                                    >
                                      <circle cx={11} cy={11} r={8} />
                                      <line x1={21} y1={21} x2="16.65" y2="16.65" />
                                    </svg>
                                  </Link>
                                  <div
                                    id="DataTables_Table_0_filter"
                                    className="dataTables_filter"
                                  >
                                    <label>
                                      {" "}
                                      <input
                                        type="search"
                                        className="form-control form-control-sm"
                                        placeholder="Search"
                                        aria-controls="DataTables_Table_0"
                                        value={searchText}
                                        onChange={(e) => {
                                            setSearchText(e.target.value);
                                            handleSearch(e.target.value);}}
                                      />
                                    </label>
                                  </div>
                                </div>
                              </div>
                                   <div className="row">
                                <div className="col-md-6">
                                  <div className="input-blocks">
                                    <label htmlFor="from-date">From Date</label>
                                    <div className="input-groupicon calender-input">
                                      <Calendar className="info-img" />
                                      <DatePicker
                            className="datetimepicker"
                            id="from-date"
                            placeholderText="From Date"
                            // selected={fromDate}
                            value={fromDate}
                            onChange={handleFromDateChange}
                            startDate={fromDate}
                            selectsStart
                            allowClear
                            // dateFormat="dd/MM/yyyy"
                          />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="input-blocks mr-2">
                                    <label htmlFor="to-date">To Date</label>
                                    <div className="input-groupicon calender-input">
                                      <Calendar className="info-img" />
                                      <DatePicker
                            id="to-date"
                            placeholderText="To Date"
                            // selected={toDate}
                            value={toDate}
                            onChange={handleToDateChange}
                            minDate={fromDate}
                            startDate={fromDate}
                            selectsEnd
                            allowClear
                            disabled={!fromDate} // disable until from date is selected
                            // dateFormat="dd/MM/yyyy"
                            // className='form-control'
                          />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <div className="input-blocks me-2">
                                <Link
                                        className="btn btn-filters ms-auto"
                                        onClick={() => {
                                          setCurrentPage(1);
                                          setPageSize(20);
                                          handleStockInfullReport();
                                          handleStockInReport(currentPage, pageSize);
                                        }}
                                      >
                                        <i data-feather="search" className="feather-search" />{" "}
                                        search{" "}
                                      </Link>
                                </div>
                                <div className="input-blocks">
                                  <button
                                    className="btn btn-reset rounded-2"
                                    onClick={handleReset}
                                  >
                                    <i data-feather="refresh-cw" className="feather-refresh-cw" /> Reset
                                  </button>
                                </div>
                              </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    onClick={toggleFilterVisibility}
                    id="filter_search"
                  >
                    <Filter className="filter-icon" />
                    <span>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>

                <div className="dropdown">
                  <button
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems
                      ?.filter((menu) => menu.label !== "Product")
                      .map((obj, i) => {
                        return (
                          <li key={i}>
                            <Checkbox
                              onChange={(e) =>
                                handleCheckboxChange(
                                  obj.value,
                                  e.target.checked
                                )
                              }
                              defaultChecked={obj.checked}
                            >
                              <div style={{ color: "black" }}> {obj.label}</div>
                            </Checkbox>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}>
                <div className="card-body pb-0">
                  <div className="row">
              <div className="col-lg-2 col-sm-6 col-12">
                                    <div className="input-blocks">
                                      
                                      <Select
                                        className="img-select"
                                        options={section}
                                        value={sectionval}
                                        onChange={handlesectionFilterChange}
                                        classNamePrefix="react-select"
                                        placeholder="Enter Section"
                                        isClearable
                                      />
                                    </div>
                                  </div>
                                  </div>
                                  </div>
                
              </div>
              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    columns={selectedColumns}
                    dataSource={filteredData}
                    ref={tableRef}
                    id="table-to-export"
                    className="table datanew dataTable no-footer custom-table"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount, // Total records count
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handleStockInReport(page, size);
                        handleStockInfullReport();
                      },
                      showSizeChanger: true, // To enable page size selection dropdown
                      pageSizeOptions: ["10", "20", "50", "100"], // Different page size options
                    }}
                    summary={() => (
                                          <Table.Summary.Row>
                                            {selectedColumns?.map((col) => (
                                              <Table.Summary.Cell key={col.dataIndex}>
                                                <b>{footerTotals[col.dataIndex] || ""}</b>
                                              </Table.Summary.Cell>
                                            ))}
                                          </Table.Summary.Row>
                                        )}
                  />
                </div>
              )}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
    </div>
  );
};
export default PayInOutReport;
